/**
 * Generic browser cookie helpers.
 *
 * All helpers that need a domain expect the *root* domain string (e.g. "fpm.cloud").
 * The cookie is set on the parent domain (prefixed with ".") so it is readable from
 * both the top-level domain and every subdomain.
 */

/**
 * @param {string} name
 * @param {string} value
 * @param {string} rootDomain  e.g. "fpm.cloud"
 * @param {{ sameSite?: string, path?: string }} [opts]
 */
export function setCookie(name, value, rootDomain, { sameSite = 'Lax', path = '/' } = {}) {
  document.cookie = `${name}=${encodeURIComponent(value)}; domain=.${rootDomain}; path=${path}; SameSite=${sameSite}`
}

/**
 * @param {string} name
 * @returns {string|null}
 */
export function getCookie(name) {
  try {
    const match = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'))
    return match ? decodeURIComponent(match[1]) : null
  } catch (_) {
    return null
  }
}

/**
 * @param {string} name
 * @param {string} rootDomain  e.g. "fpm.cloud"
 * @param {{ path?: string }} [opts]
 */
export function removeCookie(name, rootDomain, { path = '/' } = {}) {
  document.cookie = `${name}=; domain=.${rootDomain}; path=${path}; expires=Thu, 01 Jan 1970 00:00:00 GMT; SameSite=Lax`
}
